module.exports = __webpack_public_path__ + "img/photo-0120.3b2ae533.jpg";